export default "__VITE_ASSET__BhvikSsc__"